<template>
  <div class="cursos">
    <Header/>
      <div class="body">
        <div class="sobre">
            <div id="localizacao">
              <div class="img_tec">
                <img alt="aprovados" id="sap_aluno" src="../assets/alunos/sapiencia3.png">
              </div>
              <div class="img_tec">
                <h4 class="txt_endereco">Simulados</h4>
                <p class="p_sobre">Está cansado de treinar provas que não são o seu foco? O lugar que você estuda só trabalha com simulados Fuvest, Enem e Unicamp? Venha escolher o tipo de simulado que você precisa treinar!!</p>
                <p class="p_sobre">No Cursinho Sapiência você treina especificamente o que quer com SIMULADOS INDIVIDUAIS a cada 15 dias. Quem escolhe o modelo de vestibular (públicos ou privados) para treinar e o formato dela (teste ou dissertativa) é você!! E ainda: para cada simulado, você recebe um rendimento geral e por disciplina para saber onde evoluiu e onde precisa melhorar!!</p>
                <p class="p_sobre">Venha fazer parte de um cursinho que foca no seu sonho!!</p>
              </div>
            </div>
            <h4 class="msgs">Ligue e confira nossas turmas e horários</h4><br>
        </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default{
  components:{
    Header,
    Footer
  }
}
</script>

<style>
@import "../assets/style_padrao.css";
  #t{
    position: absolute;
    left: 35%;
    bottom: 75%;
    z-index: 1000;
    background: #7435af;
    margin: auto;
    border-radius: 20px;
    padding: 2% 5%;
    width: fit-content;
  }
  #a{
    position: relative;
    padding-top: 7%;
    border-radius: 25px;
    background:white;
    box-shadow: 2px 3px 18px #adadad;
  }
  #sap_aluno{
    margin-bottom: 5%;
  }
  #ast{
    color:red;
  }
  h1{
    text-align: center;
  }
  h2{
    text-align: center;
  }
  .p_sobre{
    margin-left: 4%;
    margin-right: 4%;
    text-align: justify!important;
    color: #4F4F4F;
  }
  #msg{
    text-align: center;
  }
</style>
